export enum ApplicationOwnerTypes {
  Parent = 'Vecāku',
  Child = 'Bērna',
}
